import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Efecty payment handler.
 * Handle Efecty cash payments (Colombia) by dispatching the Efecty payment action.
 */
registerHandler('efecty', {
  execute: async ({ onEfectyPaymentAttempt }) => {
    onEfectyPaymentAttempt();
  },
});
